import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  jsonLd?: object | object[];
}

const SEOHead = ({
  title,
  description,
  canonical,
  ogImage,
  ogImageWidth,
  ogImageHeight,
  jsonLd,
}: SEOHeadProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={canonical} />

    {/* Open Graph */}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={canonical} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Fussaki Spearfishing & Sportfishing Charters" />
    {ogImage && <meta property="og:image" content={ogImage} />}
    {ogImage && <meta property="og:image:type" content="image/jpeg" />}
    {ogImage && ogImageWidth && (
      <meta property="og:image:width" content={String(ogImageWidth)} />
    )}
    {ogImage && ogImageHeight && (
      <meta property="og:image:height" content={String(ogImageHeight)} />
    )}

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    {ogImage && <meta name="twitter:image" content={ogImage} />}

    {jsonLd && (
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    )}
  </Helmet>
);

export default SEOHead;
